
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Icon from 'vux/src/components/icon/index.vue'


export default {
name: 'faculty',
directives: {
TransferDom
},
components: {
Popup,
Icon
},
props: {
title: String,
conten: String
},
data () {
return {
selectedItem: {},
collegeList: [],
collegename: ''
}
},
created () {
this.getCollegeList()
},
methods: {
select (item) {
if (item === this.selectedItem) {
this.selectedItem = {}
} else {
this.selectedItem = item
}
},
onConfirm () {
this.$emit('handleConfirm', this.selectedItem)
},
onReset () {
this.collegename = ''
this.selectedItem = {}
this.getCollegeList()
},
getCollegeList () {
var params = new URLSearchParams()
params.append('collegename', this.collegename)
let pageSource = localStorage.getItem('school_source') 
let url = pageSource === 'v2' ? '/dict/college/select' : '/workorder/dict/collegelist'
this.$http({
method: 'post',
url: url,
params: params
}).then(res => {
this.collegeList = res.result
}).catch(error => {
console.log(error)
})
}
}
}




// WEBPACK FOOTER //
// ./src/components/faculty/faculty.vue